// Yuk! Temporary fix tor emove model duplicates and increment the remaining 
// label by the count of the duplicate being removed.
export function uniqueModels(models) {
    if (models) {
        for (let i in models) {
            let existingIndex = models.findIndex(comparable => comparable.label === models[i].label)

            if (existingIndex > -1 && existingIndex !== parseInt(i)) {
                models[existingIndex].count += models[i].count
                models[i].delete = true
            }
        }

        return models.filter(i => !i.delete)
    }

    return null
}